import gql from 'graphql-tag';

const sendConsentReminderEmailMutation = gql`
  mutation Web_Profiles_SendConsentReminderEmail_r1($consentStatusId: String!) {
    sendConsentReminderEmail(consentStatusId: $consentStatusId)
  }
`;

export default sendConsentReminderEmailMutation;
